import React, { useEffect, useState } from "react";
import { TutorProvider } from "../context/AiTutorContext";
import { PracticeProvider } from "../context/PracticeContext";
import { useRoot } from "../context/RootContext";
import { StorageService } from "../utils/StorageUtils";
import SyllabusComponent from "../pages/ai-tutor/Syllabus/SyllabusComponent";
import { useLocation } from "@remix-run/react";
import { isNotEmptyOrNull } from "../utils/common-utils";
import { redirectToLoginPage } from "../api/login-service";
import { useCustomNavigation } from "../hooks/useCustomNavigation";
import { ROUTES } from "../utils/navigationUtils";

export const loader = async ({ request }) => {
  const url = new URL(request.url);
  const params = Array.from(url.searchParams.entries()).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {}
  );
  return { type: "syllabus", params: params };
};

const Syllabus = () => {
  useCustomNavigation(ROUTES?.SYLLABUS);
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);
  const {
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setTaskCatagory,
    setSelectedIndex,
  } = useRoot();

  const { unlockProps } = location.state || {};

  useEffect(() => {
    setSelectedIndex(6);
    setSubTopicName("");
    setTopicName("");
    setSubjectName("");
    setTaskCatagory("");
    StorageService.removeItem("subjectMasterUUid");
    StorageService.removeItem("topicMasterUUid");
    StorageService.removeItem("videoEvents");
    StorageService.removeItem("backUpObject");
    StorageService.removeItem("assesmentInfo");
    StorageService.removeItem("ReviewJourneyId");
    setIsInitialized(true);

    if (isNotEmptyOrNull(StorageService?.getItem("redirectObject"))) {
      redirectToLoginPage();
    }
  }, []);

  if (!isInitialized) {
    return null;
  }

  return (
    <TutorProvider>
      <PracticeProvider>
        <SyllabusComponent unlockProps={unlockProps} />
      </PracticeProvider>
    </TutorProvider>
  );
};

export default Syllabus;
